import ReportPageTemplate from "./Components/ReportPageTemplate";

export default function BackOfficeReports() {
  const reportTypes = [
    { label: "Daily Revenue", api: "/pms/reports/daily-revenue" },
    { label: "Folio List", api: "/pms/reports/folio-list" },
    { label: "City Ledger Summary", api: "/pms/reports/city-ledger-summary" },
    { label: "Guest Ledger", api: "/pms/reports/guest-ledger" },
  ];

  return (
    <ReportPageTemplate
      title="Back Office Reports"
      desc="Revenue, ledgers, folios & financial summaries"
      reportTypes={reportTypes}
    />
  );
}
